<template>
  <v-tooltip bottom :open-delay="300">
    <template v-slot:activator="{ on }">
      <div class="font-size-controls d-inline-flex align-center ml-2" v-on="on">
        <v-btn
          icon
          x-small
          @click="decreaseSize"
          :disabled="fontSize <= minSize"
          class="mr-1"
        >
          <v-icon small>mdi-format-font-size-decrease</v-icon>
        </v-btn>
        
        <span class="caption text--secondary mx-1">{{ fontSize }}</span>
        
        <v-btn
          icon
          x-small
          @click="increaseSize"
          :disabled="fontSize >= maxSize"
        >
          <v-icon small>mdi-format-font-size-increase</v-icon>
        </v-btn>
      </div>
    </template>
    <span>Schriftgröße im PDF-Feld anpassen, falls mehr oder weniger Platz benötigt wird</span>
  </v-tooltip>
</template>

<script>
export default {
  name: 'FontSizeControl',
  props: {
    fontSize: { 
      type: Number, 
      required: true 
    },
    minSize: { 
      type: Number, 
      default: 8 
    },
    maxSize: { 
      type: Number, 
      default: 16 
    },
    step: { 
      type: Number, 
      default: 2 
    }
  },
  methods: {
    decreaseSize() {
      if (this.fontSize > this.minSize) {
        this.$emit('update:fontSize', this.fontSize - this.step);
      }
    },
    increaseSize() {
      if (this.fontSize < this.maxSize) {
        this.$emit('update:fontSize', this.fontSize + this.step);
      }
    }
  }
};
</script>

<style scoped>
.font-size-controls {
  border-radius: 4px;
  background-color: rgba(0, 0, 0, 0.04);
  padding: 2px 4px;
}
</style>